export class Pdc {
    titre_projet: string;
    description_projet: string;
    nom_bailleur: string;
    photo: string;
    lien_article: string;
    private errorMessage: string;

    constructor() {

        this.errorMessage = "";
    }

    canSend(): boolean {

        if (!this.titre_projet || this.titre_projet.trim() === "") {
            this.errorMessage = "Veuillez renseigner un titre.";
            return false;
        }

        if (!this.description_projet || this.description_projet.trim() === "") {
            this.errorMessage = "Veuillez renseigner une description.";
            return false;
        }

        if (!this.nom_bailleur || this.nom_bailleur.trim() === "") {
            this.errorMessage = "Veuillez renseigner le nom du bailleur.";
            return false;
        }

        if (!this.photo ) {
            this.errorMessage = "Veuillez sélectionner une photo.";
            return false;
        }

        if (!this.lien_article || this.lien_article.trim() === "") {
            this.errorMessage = "Veuillez renseigner un lien.";
            return false;
        }

        return true;
    }


    private isValidEmail(email: string): boolean {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    getErrorMessage(): string {
        return this.errorMessage;
    }
}
